import {
  Globe,
  Smartphone,
  Puzzle,
  Wrench,
  ShoppingBag,
  Package,
  Store,
  Gem,
  Server,
  Network,
  Database,
  ShieldCheck,
  KeyRound,
  Palette,
  Sparkles,
  MonitorCheck,
  Search,
  Megaphone,
  Share2,
  MailPlus,
} from "lucide-react";

export const COMPANY = {
  name: "FCY IT CONSULTANCY LTD",
  number: "13432441",
  address: "13 Dehar Crescent, London, England, NW9 7BD",
  phone: "07503336761",
  email: "info@fcyit.com",
  email2: "info@fcyitconsultancy.com",
  domain: "fcyitconsultancy.com",
  director: "Fuatcan Yetimoglu",
  sic: [
    { code: "47910", label: "Retail sale via mail order houses or via Internet" },
    { code: "62020", label: "Information technology consultancy activities" },
    { code: "62090", label: "Other information technology service activities" },
  ],
};

export const LOGO = {
  mark: "/fcy-mark.png",
  full: "/fcy-logo-full.png",
};

export const STATS = [
  { value: "50+", label: "Projects Delivered" },
  { value: "20+", label: "Service Lines" },
  { value: "7 Days", label: "Max Website Delivery" },
  { value: "24h", label: "Response Time" },
];

export const MARQUEE_ITEMS = [
  "Shopify",
  "Amazon FBA",
  "Google SEO",
  "Digital Marketing",
  "eBay",
  "Etsy",
  "React",
  "iOS & Android",
  "Python",
  "AWS",
  "Windows Keys",
  "Microsoft Office",
  "Adobe Creative Cloud",
  "AI & Automation",
  "Cyber Security",
  "MongoDB",
];

export const DELIVERY_INCLUDES = [
  { icon: Globe, label: "Domain Name", note: "Registered for you" },
  { icon: Server, label: "Premium Hosting", note: "Fast & reliable" },
  { icon: ShieldCheck, label: "SSL Certificate", note: "Secure by default" },
  { icon: Database, label: "Database", note: "Built in & managed" },
  { icon: MonitorCheck, label: "Launch to Public", note: "Live & indexed" },
];

export const SERVICE_CATEGORIES = [
  {
    id: "build",
    title: "Design & Build",
    tagline: "Websites and apps live to the public in 7 days maximum",
    services: [
      {
        icon: Globe,
        title: "Website Development",
        description:
          "Business, personal, e-commerce and marketplace websites — live in a week max, with domain, hosting, SSL and database all included in the price.",
        tags: ["7-Day Delivery", "All-Inclusive"],
      },
      {
        icon: Smartphone,
        title: "Mobile App Development",
        description:
          "Native-quality iOS and Android apps, ready for the public in one week maximum — from idea to App Store and Google Play.",
        tags: ["iOS", "Android"],
      },
      {
        icon: Puzzle,
        title: "Feature Integration",
        description:
          "Any feature integrated into any website or mobile app — payments, bookings, maps, chat, you name it.",
        tags: ["APIs", "Payments"],
      },
      {
        icon: Wrench,
        title: "Website Maintenance",
        description:
          "Ongoing updates, monitoring, backups and performance care so your site never lets you down.",
        tags: ["Monitoring", "Backups"],
      },
    ],
  },
  {
    id: "commerce-cat",
    title: "E-Commerce & Marketplaces",
    tagline: "Sell everywhere your customers are",
    services: [
      {
        icon: ShoppingBag,
        title: "Shopify Store Development",
        description:
          "High-converting Shopify stores with custom themes, apps and full feature integration.",
        tags: ["Shopify", "Custom Themes"],
      },
      {
        icon: Package,
        title: "Amazon Growth Services",
        description:
          "Expert Amazon selling: FBA, dropshipping, Private Label and White Label — end to end.",
        tags: ["FBA", "Private Label"],
      },
      {
        icon: Store,
        title: "eBay & Etsy Dropshipping",
        description:
          "Proven dropshipping setups and store management for eBay and Etsy sellers.",
        tags: ["eBay", "Etsy"],
      },
      {
        icon: Gem,
        title: "Marketplace Platforms",
        description:
          "Multi-vendor marketplace websites with seller onboarding, commissions and payouts built in.",
        tags: ["Multi-vendor", "Payouts"],
      },
    ],
  },
  {
    id: "growth",
    title: "Growth & Marketing",
    tagline: "Get found, get clicked, get customers",
    services: [
      {
        icon: Search,
        title: "Google SEO",
        description:
          "Climb Google rankings with technical SEO, keyword strategy and content optimisation that brings free traffic month after month.",
        tags: ["Rankings", "Organic Traffic"],
      },
      {
        icon: Megaphone,
        title: "Digital Marketing",
        description:
          "Full-funnel campaigns across Google and Meta — strategy, ads, tracking and reporting that turn budget into sales.",
        tags: ["Google Ads", "Meta Ads"],
      },
      {
        icon: Share2,
        title: "Social Media Marketing",
        description:
          "Content, campaigns and growth management that build a real audience for your brand.",
        tags: ["Content", "Growth"],
      },
      {
        icon: MailPlus,
        title: "Email Marketing & Automation",
        description:
          "Automated flows and campaigns that recover carts, nurture leads and bring customers back.",
        tags: ["Automation", "Campaigns"],
      },
    ],
  },
  {
    id: "infrastructure",
    title: "Infrastructure & Security",
    tagline: "Rock-solid foundations for your business",
    services: [
      {
        icon: Server,
        title: "Server Setup & Management",
        description:
          "Server installation, configuration and hardening — on-premise or in the cloud.",
        tags: ["Cloud", "On-premise"],
      },
      {
        icon: Network,
        title: "Network & Connectivity",
        description:
          "Office networks, secure connections and reliable infrastructure that just works.",
        tags: ["Networking", "VPN"],
      },
      {
        icon: Database,
        title: "Database Design & Administration",
        description:
          "Fast, safe and scalable databases — designed, migrated, optimised and maintained.",
        tags: ["SQL", "NoSQL"],
      },
      {
        icon: ShieldCheck,
        title: "Cyber Security",
        description:
          "Security audits, protection and best-practice hardening to keep your business safe.",
        tags: ["Audits", "Protection"],
      },
    ],
  },
  {
    id: "software",
    title: "Software, Licences & AI",
    tagline: "Genuine licence keys and intelligent tooling",
    services: [
      {
        icon: KeyRound,
        title: "Windows Licence Keys",
        description:
          "Genuine Microsoft Windows licence keys supplied with full activation support — for one PC or a whole office.",
        tags: ["Windows 10/11", "Genuine Keys"],
      },
      {
        icon: MonitorCheck,
        title: "Microsoft Office Setup & Licences",
        description:
          "Full Microsoft Office installation, configuration and genuine licence keys supplied.",
        tags: ["Office 365", "Setup Included"],
      },
      {
        icon: Palette,
        title: "Adobe Licence Keys",
        description:
          "Genuine licence keys for all Adobe programs — Photoshop, Illustrator, Premiere and more.",
        tags: ["Creative Cloud", "Genuine Keys"],
      },
      {
        icon: Sparkles,
        title: "AI Solutions & Automation",
        description:
          "Practical AI integrated into your workflow — chatbots, automation and intelligent tooling.",
        tags: ["AI", "Automation"],
      },
    ],
  },
];

export const CASE_STUDIES = [
  {
    title: "Shopify to Amazon FBA Expansion",
    category: "E-Commerce Growth",
    visual: "line",
    summary:
      "A London retail brand needed to move beyond its store. We rebuilt their Shopify site, launched Amazon FBA with Private Label products, and connected inventory across both channels.",
    metrics: ["+64% revenue in 6 months", "3.1x return on ad spend"],
    tags: ["Shopify", "Amazon FBA", "Private Label"],
  },
  {
    title: "Warehouse Stock Count System",
    category: "Custom Business System",
    visual: "dashboard",
    summary:
      "A distribution company was losing money to stock errors. We designed a bespoke stock counting system with barcode scanning, live dashboards and automated reporting.",
    metrics: ["-40% stock discrepancies", "Real-time reporting"],
    tags: ["Custom System", "Dashboards"],
  },
  {
    title: "Multi-Vendor Marketplace Build",
    category: "Marketplace Platform",
    visual: "network",
    summary:
      "An entrepreneur wanted their own niche marketplace. We delivered a full multi-vendor platform with seller onboarding, secure payments and commission management — live in record time.",
    metrics: ["10,000+ live listings", "Sub-1.5s page loads"],
    tags: ["Marketplace", "Payments"],
  },
  {
    title: "SME Security & Infrastructure Overhaul",
    category: "Cyber Security",
    visual: "shield",
    summary:
      "A growing SME needed enterprise-grade security on an SME budget. We hardened servers, rebuilt the network, rolled out 2FA and trained the team.",
    metrics: ["0 incidents post-launch", "Company-wide 2FA"],
    tags: ["Security", "Networking"],
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Describe Your Business",
    description:
      "Tell us what you do and what you need through the contact form — a website, an app, a system, or all three.",
  },
  {
    step: "02",
    title: "Receive Your Roadmap",
    description:
      "Within 24 hours you get a clear proposal: scope, timeline and one all-inclusive price. No jargon, no surprises.",
  },
  {
    step: "03",
    title: "We Build — Fast",
    description:
      "Websites and mobile apps are ready for the public in 7 days maximum. Daily progress, every detail polished.",
  },
  {
    step: "04",
    title: "Launch, Maintain & Scale",
    description:
      "Domain, hosting, SSL and database are already in the price — we take you live, then stay by your side.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Fuatcan rebuilt our Shopify store and got us selling on Amazon FBA. Revenue is up dramatically and everything simply works. The most responsive consultant we have ever used.",
    name: "James Whitfield",
    role: "Founder, London Retail Brand",
  },
  {
    quote:
      "The warehouse stock system FCY built saved us from constant counting errors. We described our problem, and weeks later we had a system that fit us perfectly.",
    name: "Sarah Collins",
    role: "Operations Director, Distribution SME",
  },
  {
    quote:
      "Our website was live in six days — domain, hosting, everything included. Then their Google SEO work took us to page one for our main keywords.",
    name: "Mehmet Aydin",
    role: "E-Commerce Entrepreneur",
  },
  {
    quote:
      "From our clinic website to Windows and Office licences for the whole team, FCY handles all of our IT. One contact, everything sorted.",
    name: "Priya Sharma",
    role: "Clinic Owner, North London",
  },
];

export const FAQS = [
  {
    question: "What services does FCY IT Consultancy offer?",
    answer:
      "Everything IT: websites (business, personal, e-commerce, marketplace), iOS and Android mobile apps, Google SEO and digital marketing, website maintenance, cyber security, servers, networks and databases, Shopify stores, Amazon services (FBA, dropshipping, Private Label, White Label), eBay and Etsy dropshipping, genuine Windows, Microsoft Office and Adobe licence keys, AI solutions, and fully custom business systems.",
  },
  {
    question: "How fast will my website or mobile app be ready?",
    answer:
      "Fast. Websites and mobile apps are ready for the public in 7 days maximum — that includes design, build, testing and launch. You see progress daily and go live within the week.",
  },
  {
    question: "What is included in the website price?",
    answer:
      "Everything. Your domain name, premium hosting, SSL certificate and database are all included in the price — along with design, development and public launch. One price, no hidden extras, no surprise renewals sprung on you.",
  },
  {
    question: "Can you get my business found on Google?",
    answer:
      "Yes — Google SEO and digital marketing are core services. We handle technical SEO, keyword strategy and content optimisation to climb the rankings, plus paid campaigns on Google and Meta when you want faster results.",
  },
  {
    question: "Are the Windows, Microsoft Office and Adobe licence keys genuine?",
    answer:
      "Yes — we supply genuine licence keys for Microsoft Windows, Microsoft Office and all Adobe programs, and we can also handle the full installation and activation for you or your whole team.",
  },
  {
    question: "Can you help me start selling on Amazon, eBay or Etsy?",
    answer:
      "Absolutely. Amazon is a specialty: FBA, dropshipping, Private Label and White Label. We also set up and manage eBay and Etsy dropshipping operations, from account setup to product strategy.",
  },
  {
    question: "My business needs a custom system. Can you build it?",
    answer:
      "Yes. Describe your business and what you need — a warehouse stock counting system, a camera system, a reporting system, anything. We design and build systems around exactly how your business works.",
  },
  {
    question: "How do I get in touch and how fast do you respond?",
    answer:
      "All enquiries come through the Contact Us form on this website — it is the single, direct line to the director. You will receive a response within 24 hours.",
  },
];

export const SERVICE_OPTIONS = [
  "Website Development",
  "Mobile App Development (iOS / Android)",
  "E-Commerce / Shopify Store",
  "Marketplace Platform",
  "Amazon Services (FBA / Dropshipping / PL / WL)",
  "eBay / Etsy Dropshipping",
  "Google SEO",
  "Digital Marketing",
  "Cyber Security",
  "Servers / Network / Database",
  "Website Maintenance",
  "Windows / Office / Adobe Licence Keys",
  "AI Solutions & Automation",
  "Custom Business System",
  "Other / Not Sure",
];

export const BUDGET_OPTIONS = [
  "Under £500",
  "£500 – £1,000",
  "£1,000 – £5,000",
  "£5,000 – £10,000",
  "£10,000+",
  "Not sure yet",
];
